import React from 'react';
import KickImage from 'Reuseables/KickImage';

import { IBigItemTitleProps } from './BigItemTitle.definitions';

/** CSS import */
import Styles from './BigItemTitle.module.scss';

const BigItemTitle: React.FC<IBigItemTitleProps> = ({
  text,
}: IBigItemTitleProps) => {
  return <p className={Styles['text']}>{text}</p>;
};

export default BigItemTitle;
